import React from 'react';
import { layers } from '@atlaskit/theme/constants';
import Spinner from '@atlaskit/spinner';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
var overlayZindex = layers.modal() + 10;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Blanket = styled.div({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: overlayZindex
});
Blanket.displayName = 'Blanket';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SpinnerWrapper = styled.div({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
});
SpinnerWrapper.displayName = 'SpinnerWrapper';
var defaultProps = {
  blankedColor: 'none',
  invertSpinnerColor: false
};
export default (function (_ref) {
  var blankedColor = _ref.blankedColor,
    invertSpinnerColor = _ref.invertSpinnerColor;
  return /*#__PURE__*/React.createElement(Blanket, {
    style: {
      backgroundColor: blankedColor || defaultProps.blankedColor
    },
    "data-testid": 'media-modal-spinner-blanket'
  }, /*#__PURE__*/React.createElement(SpinnerWrapper, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "large",
    appearance: invertSpinnerColor || defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
    testId: 'media-modal-spinner'
  })));
});